export default {
      id: "heart-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#heart",
      toString: function () {
        return this.url;
      }
    }